import React, { useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { videoSourcesScreen_Query } from "@relay/videoSourcesScreen_Query.graphql";
import { CreateVideoSourceButton } from "./parts/create-video-source-button";
import { VideoSourcesTable } from "./parts/video-sources-table";
import { VideoSourcesScreenContext } from "./video-sources.context";
import { QUERY } from "./video-sources.graphql";
import { wrapperClass } from "./video-sources.styles";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const VideoSourcesScreen = () => {
	const { t } = useTranslation("common");
	const query = useLazyLoadQuery<videoSourcesScreen_Query>(QUERY, {});
	const [connectionId, setConnectionId] = useState("");

	const canRead = useHasPermissions(["UserInAccountPermission_VimeoVideoSourceAdmin_Read"]);

	if (!canRead) return <NoAccess />;

	return (
		<VideoSourcesScreenContext.Provider value={{ connectionId, setConnectionId }}>
			<BaseScreen title={t("videoSources.title")}>
				<div className={wrapperClass}>
					<CreateVideoSourceButton />
				</div>
				<VideoSourcesTable queryFragmentRef={query} />
			</BaseScreen>
		</VideoSourcesScreenContext.Provider>
	);
};
